module.exports = __webpack_public_path__ + "img/pexels-philip-boakye-910143.534e3fe3.jpg";